import { EyeCloseIcon, EyeIcon } from 'assets/icons';
import './styles.scss';

interface HidePasswordProps {
	inputType: string;
	onClick: () => void;
	error?: boolean;
	whiteIcon?: boolean;
}

export const HidePassword = (props: HidePasswordProps) => {
	const { inputType, onClick, error, whiteIcon } = props;

	return (
		<div className={`hidePassword ${error && 'errorPassword'} ${whiteIcon && 'whiteIcon'}`} onClick={onClick}>
			{inputType === 'password' ? <EyeIcon /> : <EyeCloseIcon />}
		</div>
	);
};

export default HidePassword;
